/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_License_Row_Pnb_ScopeInputs */

const es_marketplace_seo_license_row_pnb_scope = /** @type {(inputs: Marketplace_Seo_License_Row_Pnb_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diurna: 2 millas desde puerto; en vela, 5 millas desde puerto habilitado.`)
};

const gl_marketplace_seo_license_row_pnb_scope = /** @type {(inputs: Marketplace_Seo_License_Row_Pnb_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diurna: 2 millas dende porto; en vela, 5 millas dende porto habilitado.`)
};

const en_marketplace_seo_license_row_pnb_scope = /** @type {(inputs: Marketplace_Seo_License_Row_Pnb_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Day: 2 miles from port; under sail, 5 miles from an authorised port.`)
};

/**
* | output |
* | --- |
* | "Day: 2 miles from port; under sail, 5 miles from an authorised port." |
*
* @param {Marketplace_Seo_License_Row_Pnb_ScopeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_license_row_pnb_scope = /** @type {((inputs?: Marketplace_Seo_License_Row_Pnb_ScopeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_License_Row_Pnb_ScopeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_license_row_pnb_scope(inputs)
	if (locale === "en") return en_marketplace_seo_license_row_pnb_scope(inputs)
	return es_marketplace_seo_license_row_pnb_scope(inputs)
});